<template>
  <v-card style="border-radius: 7px" width="97%" class="elevation-20">
    <v-card-title class="py-0">
      <v-list width="100%">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="headline">45678</v-list-item-title>
            <v-list-item-subtitle>Total Ideas</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon fab x-large>mdi-square-inc-cash</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card-title>
    <v-card-text width="100%" class="py-0">
      <GChart  type="ColumnChart" :data="chartData" :options="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      // Array will be automatically processed with visualization.arrayToDataTable function
      chartData: [
        ["Year", "Sales", "Expenses", "Profit"],
        ["2014", 1000, 400, 200],
        ["2015", 1170, 460, 250],
        ["2016", 660, 1120, 300],
        ["2017", 1030, 540, 350]
      ],
      chartOptions: {
        chart: {
          title: "Company Performance",
          subtitle: "Sales, Expenses, and Profit: 2014-2017"
        }
      }
    };
  }
};
</script>